var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7111","cy":"7112","r":"7111","fill":"#1977f3","key":0}),React.createElement("path",{"d":"M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z","fill":"#fff","key":1})]);
}

SocialFacebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 14222 14222"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
